import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {HeaderService} from './header-service';
import {SafariStyleService} from './safari-style.service';
import {FooterService} from './footer-service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  constructor(private httpClient: HttpClient,
              protected headerService: HeaderService,
              public safariStyleService: SafariStyleService,
              public footerService: FooterService) {}

  private active: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private newActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private mobileListMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private openOverlay: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private openSecondForm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private prevHeader: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private mobileHeaderStyle: BehaviorSubject<string> = new BehaviorSubject<string>('white');
  private mobileHeaderSpecialStyle: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private inputFocused = false;

  setActive(value?: boolean) {
    let v
    if (value !== undefined) {
      v = value;
    } else {
      v = !this.active.value;
    }
    this.setMobileListMenu(false);
    const el = document.getElementById('body');
    const prev = this.headerService.getActiveInterface();
    if (el) {
      if (v) {
        el.style.overflow = 'hidden';
        this.headerService.setActiveInterface('header-container-menu');
      } else {
        el.style.overflow = 'inherit';
        this.headerService.setActiveInterface(this.prevHeader.value);
      }
      this.prevHeader.next(prev);
    }
    this.active.next(v);
  }

  getActive() {
    return this.active.value;
  }

  setMobileListMenu(value: boolean) {
    this.mobileListMenu.next(value);
  }

  getMobileListMenu() {
    return this.mobileListMenu.value;
  }

  setMobileOverlay(value: boolean) {
    this.openOverlay.next(value);
  }

  getMobileOverlay() {
    return this.openOverlay.value;
  }

  setMobileForm(value: boolean) {
    this.openSecondForm.next(value);
  }

  getMobileForm() {
    return this.openSecondForm.value;
  }

  getMobileActive() {
    return this.newActive.value;
  }

  setMobileActive(value: boolean) {
    if (value === true) {
      this.setMobileStyle('white');
    }
    this.newActive.next(value);
  }

  getMobileStyle() {
    return this.mobileHeaderStyle.value;
  }

  setMobileStyle(value: string) {
    if (this.getMobileActive() === true) {
      this.safariStyleService.setColor('white');
      return;
    }
    if (value === 'none') {
      this.safariStyleService.setColor(this.footerService.getFooterColor());
    } else {
      this.safariStyleService.setColor(value);
    }
    this.mobileHeaderStyle.next(value);
  }

  getMobileSpecialStyle() {
    return this.mobileHeaderSpecialStyle.value;
  }

  setMobileSpecialStyle(value: boolean) {
    this.mobileHeaderSpecialStyle.next(value);
  }

  setInputFocused(focused: boolean) {
    this.inputFocused = focused;

    if (this.safariStyleService.isMobileSafari() || this.safariStyleService.isYandexBrowser()) {
      if (focused) {
        this.safariStyleService.setBottomBlockVisibility(true);
      } else {
        this.safariStyleService.setBottomBlockVisibility(false);
      }
    }
  }

  getInputFocused(): boolean {
    return this.inputFocused;
  }
}
